export const API_HOST =
	process.env.REACT_APP_IS_PROD === 'true'
		? process.env.REACT_APP_PROD_API_HOST
		: process.env.REACT_APP_DEV_API_HOST

export const STRIPE_KEY =
	process.env.REACT_APP_IS_PROD === 'true'
		? process.env.REACT_APP_STRIPE_LIVE_KEY || ''
		: process.env.REACT_APP_STRIPE_TEST_KEY || ''
